module.exports = __webpack_public_path__ + "img/angststoerungen_960.26ee9bcd.png";